// Product Gallery Auto Rotate
class ProductGallerySlider {
  constructor(wrapper) {
    // 🔒 Prevent double initialization
    if (wrapper.classList.contains('is-initialized')) return;
    wrapper.classList.add('is-initialized');

    this.wrapper = wrapper;
    this.slides = wrapper.querySelectorAll('.gallery-slide');
    this.totalSlides = this.slides.length;

    // Get settings from data attributes
    this.settings = {
      enableAutoRotate: wrapper.dataset.enableAutoRotate === 'true',
      rotationSpeed: parseInt(wrapper.dataset.rotationSpeed, 10) || 3000,
      pauseOnHover: wrapper.dataset.pauseOnHover === 'true'
    };

    // State
    this.currentSlide = 0;
    this.interval = null;
    this.isPaused = false;
    this.resumeTimeout = null;
    this.hasUserInteracted = false;

    if (this.totalSlides > 1) {
      this.init();
    }
  }

  init() {
    // Show first slide
    this.showSlide(this.currentSlide);

    // Setup features
    this.setupNavigation();
    this.setupPagination();
    this.setupThumbnails();

    // Auto rotate
    if (this.settings.enableAutoRotate) {
      this.startAutoRotation();
    }

    // Pause on hover
    if (this.settings.pauseOnHover) {
      this.setupHoverPause();
    }

    // Swipe support
    this.setupSwipe();

    console.log('Gallery initialized:', {
      slides: this.totalSlides,
      settings: this.settings
    });
  }

  showSlide(index) {
  this.slides.forEach(slide => {
    slide.style.display = 'none';
    slide.classList.remove('active');
  });

  this.slides[index].style.display = 'flex';
  this.slides[index].classList.add('active');
  this.currentSlide = index;

  // 🔥 Preload NEXT image (Dawn behavior)
  const nextIndex = (index + 1) % this.totalSlides;
  this.preloadImage(nextIndex);

  this.updatePagination(index);
  this.updateThumbnails(index);
}


  nextSlide() {
    this.showSlide((this.currentSlide + 1) % this.totalSlides);
  }

  prevSlide() {
    this.showSlide(
      this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1
    );
  }

  goToSlide(index) {
    if (index >= 0 && index < this.totalSlides) {
      this.showSlide(index);
    }
  }

  pauseForInteraction() {
    if (!this.settings.enableAutoRotate) return;

    this.hasUserInteracted = true;
    this.isPaused = true;

    clearTimeout(this.resumeTimeout);
    this.resumeTimeout = setTimeout(() => {
      this.isPaused = false;
    }, 5000);
  }

  setupNavigation() {
    const prevBtn = this.wrapper.querySelector('.gallery-nav.prev');
    const nextBtn = this.wrapper.querySelector('.gallery-nav.next');

    prevBtn?.addEventListener('click', e => {
      e.preventDefault();
      this.pauseForInteraction();
      this.prevSlide();
    });

    nextBtn?.addEventListener('click', e => {
      e.preventDefault();
      this.pauseForInteraction();
      this.nextSlide();
    });

    document.addEventListener('keydown', e => {
      if (!this.wrapper.contains(document.activeElement)) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.pauseForInteraction();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.pauseForInteraction();
        this.nextSlide();
      }
    });
  }

  setupPagination() {
    this.wrapper.querySelectorAll('.gallery-pagination-dot').forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.pauseForInteraction();
        this.goToSlide(i);
      });
    });
  }

  setupThumbnails() {
    this.wrapper.querySelectorAll('.gallery-thumbnail').forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        this.pauseForInteraction();
        this.goToSlide(i);
      });
    });
  }

  updatePagination(index) {
    this.wrapper.querySelectorAll('.gallery-pagination-dot')
      .forEach((dot, i) => dot.classList.toggle('active', i === index));
  }

  updateThumbnails(index) {
  const thumbnails = this.wrapper.querySelectorAll('.gallery-thumbnail');

  thumbnails.forEach((thumbnail, i) => {
    thumbnail.classList.toggle('active', i === index);

    // ❌ DO NOT auto-scroll page
    // Only scroll thumbnails if user clicked (not autoplay)
    if (
      i === index &&
      this.hasUserInteracted &&
      thumbnail.closest('.gallery-thumbnails')
    ) {
      thumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  });
}


  startAutoRotation() {
    clearInterval(this.interval);

    this.interval = setInterval(() => {
      if (!this.isPaused) {
        this.nextSlide();
      }
    }, this.settings.rotationSpeed);
  }

  setupHoverPause() {
    this.wrapper.addEventListener('mouseenter', () => {
      if (this.settings.enableAutoRotate) this.isPaused = true;
    });

    this.wrapper.addEventListener('mouseleave', () => {
      if (this.settings.enableAutoRotate) this.isPaused = false;
    });

    this.wrapper.addEventListener('touchstart', () => {
      if (this.settings.enableAutoRotate) this.isPaused = true;
    });

    this.wrapper.addEventListener('touchend', () => {
      setTimeout(() => {
        if (this.settings.enableAutoRotate) this.isPaused = false;
      }, 1000);
    });
  }

  setupSwipe() {
    let startX = 0;
    const minDistance = 50;

    this.wrapper.addEventListener('touchstart', e => {
      startX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.wrapper.addEventListener('touchend', e => {
      const endX = e.changedTouches[0].screenX;
      const diff = endX - startX;

      if (Math.abs(diff) > minDistance) {
        this.pauseForInteraction();
        diff > 0 ? this.prevSlide() : this.nextSlide();
      }
    }, { passive: true });
  }

preloadImage(index) {
  const slide = this.slides[index];
  if (!slide) return;

  const img = slide.querySelector('img');
  if (!img || img.dataset.preloaded) return;

  const src = img.getAttribute('src');
  if (!src) return;

  const preload = new Image();
  preload.src = src;

  img.dataset.preloaded = 'true';
}





}

/* =============================
   INITIALIZATION
============================= */

// Normal page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery-wrapper')
    .forEach(wrapper => new ProductGallerySlider(wrapper));
});

// Section load (featured product, etc.)
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.product-gallery-wrapper')
    .forEach(wrapper => new ProductGallerySlider(wrapper));
});

// 🔥 QUICK ADD / QUICK MODAL (FIX)
document.addEventListener('quick-add:open', event => {
  event.target.querySelectorAll('.product-gallery-wrapper')
    .forEach(wrapper => new ProductGallerySlider(wrapper));

  // Fix layout/media issues in modal
  window.dispatchEvent(new Event('resize'));
});


/* =============================
   QUICK MODAL – GUARANTEED FIX
============================= */

const observeQuickModal = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // Case 1: wrapper itself is added
        if (node.classList?.contains('product-gallery-wrapper')) {
          new ProductGallerySlider(node);
        }

        // Case 2: wrapper exists inside added content
        const wrappers = node.querySelectorAll?.('.product-gallery-wrapper');
        if (wrappers?.length) {
          wrappers.forEach(wrapper => {
            new ProductGallerySlider(wrapper);
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// Start observing immediately
observeQuickModal();
